<section>
  @if (!editing.newItem) {
    <h3>Edit Item: {{editing.name}}</h3>
  }
  @if (editing.newItem) {
    <h3>Add New Item</h3>
  }
  <form #formDiv="ngForm" [formGroup]="formComponent">
    <ng-template ebComponentHost></ng-template>
    <div class="form-button-group">
      <button class="button hollow margin-right" (click)="cancel()">Cancel</button>
      <button class="button" (click)="save()" [disabled]="formDiv.invalid">Save</button>
    </div>
  </form>
</section>
